import { SERVICE_NAME } from "@/config/serviceNames";
import { requests } from ".";
import { EntityType, Module } from "@/constants";
import store from "@/store";

const user = store.state.auth.user;
const userEmail = user?.email;

const ISVService = {
  syncBrandAndCampaign: (companyId: string, locationId: string) =>
    requests(SERVICE_NAME.REVEX_SAAS_ISV_API).post(
      `compliance/${companyId}/sync-compliance/${locationId}`
    ),

  addBusinessProfileFailureReason: (
    companyId: string,
    locationId: string,
    payload: any
  ) =>
    requests(SERVICE_NAME.REVEX_SAAS_ISV_API).post(
      `compliance/${companyId}/standard-registration/${locationId}/secondary-customer-profile/failure-reason`,
      payload
    ),

  deleteTollFreeTicket: (locationId: string) =>
    requests(SERVICE_NAME.REVEX_SAAS_ISV_API).delete(
      `tollFree/toll-free-registration/${locationId}`
    ),

  updateSMSLimit: (companyId: string, payload: any) => {
    return requests(SERVICE_NAME.LC_PHONE_API).post(
      `rate-limiter/company/${companyId}/sms/usage`,
      payload
    )
  },
  uploadNumberPricingCsv: (formData: FormData) =>
    requests(SERVICE_NAME.LC_PHONE_API).post(
      "/billing-pricing/upsert-number-pricing/",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }
    ),

  handleTwilioISVMigration: (data: any) =>
    requests(SERVICE_NAME.REVEX_SAAS_ISV_API).log({
      module: Module.LC_DOMAIN,
      entityType: EntityType.LC_COMMUNICATION,
      entityId: userEmail || EntityType.UNKNOWN
    })
    .post(
      "twilio/migration-data",
      { data }
    ),

  handleTwilioISVMigrationWithFile: (formData: FormData) =>
    requests(SERVICE_NAME.REVEX_SAAS_ISV_API).log({
      module: Module.LC_DOMAIN,
      entityType: EntityType.LC_COMMUNICATION,
      entityId: userEmail || EntityType.UNKNOWN
    }).post(
      "twilio/migration-data",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }
    ),

  suspendTwilioAccount: (payload: { locationId: string; reason: string }) =>
    requests(SERVICE_NAME.LC_PHONE_API).post(
      "/twilio-accounts/suspend",
      payload
    ),
    
  bulkSuspendTwilioAccounts: (formData: FormData) =>
    requests(SERVICE_NAME.LC_PHONE_API).post(
      "/twilio-accounts/bulk-suspend",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }
    ),
};

export default ISVService;
